import React from 'react'
import { translate } from 'react-i18next'
import Img from 'gatsby-image'
import { StatCircleElement } from './styled-components'

const StatCircle = ({ data, imageDictionary, lng }) => {
  return (
    <StatCircleElement circleColor={data.circleColor}>
      <div className='circleLabel'>
        {
          lng.match(/^en/) &&
          <Img sizes={imageDictionary[`${data.image}`].sizes} />
        }

        {
          lng === 'es' &&
          <Img sizes={imageDictionary[`${data.image}-es`].sizes} />
        }
      </div>
      { data.number }
    </StatCircleElement>
  )
}

export default translate()(StatCircle)



// WEBPACK FOOTER //
// ./src/components/modules/StatCircle/StatCircle.js